import { SearchLg } from "@untitled-ui/icons-react";
import { useState } from "react";

import { cn } from "@/lib/utils";

import Input, { type InputProps } from "../../Input";

type Props = InputProps;

export default function ComboboxInput({ className, ...props }: Props) {
  const [query, setQuery] = useState("");

  return (
    <div className="mx-1.5 my-0.5 flex">
      <Input
        startIcon={<SearchLg className="size-5" />}
        data-slot="command-input"
        autoFocus
        className={cn(
          "placeholder:text-muted-foreground flex h-10 w-full rounded-md bg-transparent py-3 text-sm outline-hidden focus:ring-0 disabled:cursor-not-allowed disabled:opacity-50",
          className,
        )}
        {...props}
        value={query}
        onChange={(e) => {
          setQuery(e.target.value);
          props.onChange?.(e);
        }}
      />
    </div>
  );
}
